import Service from '../../../service/api';
import store from '../../store';
import router from '../../../router/index';

const v3Module = {
  namespaced: true,
  state: {
    //template state
    fetchBy: null,
    templates: [],
    courseProgress: [],
    resetPage: null,
    completeContent: [],
    templateCount: 0,
    currentPage: 0,
    score: 0,
    maxScore: 0,
    saveScoreAndProgress: null,
    mainCodeItem: null, //เป็นตัวระบุว่าตอนนี้อยู่ที่ sub content ไหน ตอนเเรกว่าจะใช้ content หลักเเต่ดูเเล้วต้องใช้ตัวรองเเทนแล้วยิงไปแปลงข้อมูลตัวเเม่มา
    isEnroll: false,
    v3Data: {},
    isPretest: false,
    v3EnrollData: null,
    v3TeacherCourse: [],
    isLearn: false,
    isUpdateProgress: false,
    lessonCode: null,
    isPostTest: false,
    v3ParentCodeItem: [],
    mainLessonCode: null,
    isLesson: false,
    /// for checking status
    checkingResult: true,
    notifyEnroll: false,
    //catch error form saving
    saveError: false,
    lessonLock: [],
    lockData: {},
  },
  mutations: {
    //func
    setTemplates(state, data) {
      state.templates = data;
    },
    clearCourseProgress(state) {
      state.courseProgress = [];
    },
    setCourseProgress(state, data) {
      state.courseProgress = data;
    },
    setFetchDataBy(state, data) {
      state.fetchBy = data;
    },
    setResetPage(state, data) {
      state.resetPage = data;
    },

    // ไม่ใช้เเล้ว!!! แต่เผื่อไว้สำหรับการรวบข้อมูลเเล้วส่ง
    // ใช้เก็บหน้าที่เรียนไปเเล้ว stake ข้อมูล
    // จากนั้นต้องเอาไปใช้กับฟังชั่นในการบันทึกข้อมูลเข้า DB
    // หลังจากได้รับ reponse ของ backend ที่ส่งกลับมาว่าบันทึกสำเร็จจึงทำการ ล้างข้อมูลให้เหลือ array ว่าง
    setCompleteContent(state, data) {
      console.log('xxxxxxxxxxxxxxxxx', data);
      const refine = {
        codeItem: data.codeItem,
        template: data.template || null,
        content: data.content || null,
        type: data.type,
        answering: data.answering || [],
        progress: data.progress || 0,
        score: data.score || 0,
        complete: true,
      };

      // // add more items here if needed
      // answering: [
      //     {
      //       match: null,
      //       answer: 'ants',
      //       index: 1
      //     }
      //   ],
      if (state.completeContent.length == 0) {
        state.completeContent.push(refine);
      } else {
        for (let i = 0; i < state.completeContent.length; i++) {
          // ใช้ลูปในการป้องกันการเก็บซํ้า แต่แทนที่ด้วยข้อมูลใหม่เเทน
          let content = state.completeContent[i];
          if (content.codeItem == refine.codeItem) {
            content = refine;
          }
          state.completeContent.push(content);
        }
      }
      console.log('completeContent', state.completeContent);
    },

    // ใช้สำหรับเคลียข้อมูลใน storage ของหน้าที่ทำเสร็จเเล้ว
    // เรียกใช้หลังจากเรียก api ที่ใช้บันทึกข้อมูลหน้าที่เรียนไปเเล้วเพื่อลบข้อมูลใน storage
    clearCompleteContent(state) {
      state.completeContent = [];
    },

    keepScore(state, data) {
      console.log('==============');
      console.log('data intput', data.score, data.maxScore);
      state.maxScore = state.maxScore + data.maxScore;
      state.score = state.score + data.score;
      console.log('score', state.score, 'maxScore', state.maxScore);
      console.log('==============');
    },
    clearScore(state) {
      state.maxScore = 0;
      state.score = 0;
    },

    // บันทึกคะแนนในตัวแม่ของ content
    saveScoreAndProgress(state, data) {
      state.saveScoreAndProgress = data;
    },
    clearScoreAndProgress(state) {
      state.saveScoreAndProgress = null;
    },

    // //เก็บ content ตัวหลักสำหรับเก็บ progress แบบกลุ่ม
    stampMainCodeItem(state, data) {
      console.log(data, 'stamp');

      state.mainCodeItem = data;
    },
    clearMainCodeItem(state) {
      state.mainCodeItem = null;
    },

    //isUpdateProgress stat
    v3IsUpdateProgressOn(state) {
      state.isUpdateProgress = true;
    },
    v3IsUpdateProgressOff(state) {
      state.isUpdateProgress = false;
    },
    //isPostTest
    v3IsPostTestOn(state) {
      state.isPostTest = true;
    },
    v3IsPostTestOff(state) {
      state.isPostTest = false;
    },

    //lessonCode
    stampLessonCode(state, data) {
      // console.log('stampLessonCode', data);
      state.lessonCode = data;
    },
    clearLessonCode(state) {
      state.lessonCode = null;
    },

    //main lesson
    stampMainLesson(state, data) {
      state.mainLessonCode = data;
    },
    clearMainLesson(state) {
      state.mainLessonCode = null;
    },

    //isLesson
    v3IsLessonOn(state) {
      state.isLesson = true;
    },
    v3IsLessonOff(state) {
      state.isLesson = false;
    },

    // // enroll course in overview page
    v3CourseEnroll(state, data) {
      state.isEnroll = true;
    },
    v3SetCourseEnroll(state) {
      state.isEnroll = false;
    },
    v3IsEnroll(state, data) {
      state.v3EnrollData = data;
    },
    //for isLearn
    v3IsLearnOn(state) {
      state.isLearn = true;
    },
    v3IsLearnOff(state) {
      state.isLearn = false;
    },

    // // หน้าจัดการข้อมูลของ course ของผู้สอน
    v3IsTeaching(state, data) {
      state.v3TeacherCourse = data;
    },
    v3ClearTeaching(state) {
      state.v3TeacherCourse = [];
    },

    //notifyEnroll
    v3notifyEnrollOn(state) {
      state.notifyEnroll = true;
    },
    v3notifyEnrollOff(state) {
      state.notifyEnroll = false;
    },

    // //====================================

    // สำหรับเก็บหน้า pretest
    // โลจิกคร่าวๆคือ หากเช็ค progress ของ pretest เเล้วว่าไม่ครบ 100 ให้เปิด
    // หลังจากบันทึกข้อมูลหมดเเล้วให้ปิด
    // รันในหน้า Menu
    v3PretestOn(state) {
      state.isPretest = true;
    },
    v3PretestOff(state) {
      state.isPretest = false;
    },

    v3ParentCodeItem(state, data) {
      state.v3ParentCodeItem = data;
    },
    clearV3ParentCodeItem(state) {
      state.v3ParentCodeItem = [];
    },

    //checking result for userAnswer
    v3CheckingResultTrue(state) {
      state.checkingResult = true;
    },
    v3CheckingResultFalse(state) {
      state.checkingResult = false;
    },

    //save error
    v3SaveErrorOn(state) {
      state.saveError = true;
    },
    v3SaveErrorOff(state) {
      state.saveError = false;
    },

    //LessonLock
    v3LessonLockOn(state, data) {
      state.lessonLock = data;
    },
    v3LessonLockOff(state) {
      state.lessonLock = [];
    },

    //lock data use for keep lesson lock to another page
    setLockData(state, data) {
      state.lockData = data;
    },
    clearLockData(state) {
      state.lockData = {};
    },
  },
  actions: {
    fetchTemplateByCode({commit}, payload) {
      // เรียกข้อมูลโดยใช้ codeItem
      Service.v3GetTemplateByCode(payload)
        .then((res) => {
          commit('setTemplates', res.data.data);
        })
        .catch((error) => {
          console.log('Error fetch template', error);
        });
    },
    fetchTemplateByContent({commit}, payload) {
      // เรียกข้อมูลโดยใช้ Content ID
      Service.v3GetTemplateByContent(payload)
        .then((res) => {
          console.log('setTemplates', res.data.data);
          commit('setTemplates', res.data.data);
        })
        .catch((error) => {
          console.log('Error fetch template', error);
        });
    },
    fetchCourseProgress({commit}, payload) {
      Service.v3GetCourseProgress(payload)
        .then((res) => {
          commit('setCourseProgress', res.data.data);
        })
        .catch((error) => {
          console.log('Error fetch progress', error);
        });
    },
    saveContent({commit}, payload) {
      Service.v3SaveContent(payload)
        .then((res) => {
          console.log('success');
          //save Content waiting respond to state
          //using getter on state to loading false
        })
        .catch((error) => {
          console.log('Error saveContent', error);
          alert('Something went wrong. Please try to login again');
          router.push('/');
        });
    },
    saveScoreAndProgress({commit}, payload) {
      return Service.v3SaveScoreAndProgress(payload)
        .then((res) => {
          commit('saveScoreAndProgress', res.data.data);
          console.log('Score & Progress Success');
        })
        .catch((error) => {
          console.log('Error saveContent', error);
          //commit Error on
          commit('v3SaveErrorOn');
          throw error;
        });
    },
    v3CourseEnroll({commit}, payload) {
      // สมัครเข้าเรียนวิชาในหน้า overview
      Service.v3CourseEnroll(payload)
        .then((res) => {
          commit('v3CourseEnroll', res.data.data);
          console.log('Enroll is complete');
        })
        .catch((error) => {
          console.log('Error v3CourseEnroll', error);
          commit('v3notifyEnrollOn');
        });
    },
    v3IsEnroll({commit}, payload) {
      // สมัครเข้าเรียนวิชาในหน้า overview
      Service.v3IsEnroll(payload)
        .then((res) => {
          const data = {data: res.data.data, isEnroll: true};
          commit('v3IsEnroll', data);
        })
        .catch((error) => {
          console.log('Error v3IsEnroll', error);
          const data = {data: null, isEnroll: false};
          commit('v3IsEnroll', data);
        });
    },
    v3IsTeaching({commit}) {
      // สมัครเข้าเรียนวิชาในหน้า overview
      Service.v3IsTeaching()
        .then((res) => {
          commit('v3IsTeaching', res.data.data);
        })
        .catch((error) => {
          console.log('Error v3IsTeaching', error);
          commit('v3ClearTeaching');
        });
    },
    v3GetParent({commit}, payload) {
      Service.v3GetParent(payload)
        .then((res) => {
          commit('v3ParentCodeItem', res.data.data);
        })
        .catch((error) => {
          console.log('Error saveContent', error);
        });
    },

    v3FilterParent({state, commit, dispatch}, data) {
      //data = codeItem
      //filter MockParent by data
      console.log(state.v3ParentCodeItem, 'template parent code');
      const matchCodeItem = state.v3ParentCodeItem.includes(data);
      //if match codeItem true

      if (matchCodeItem) {
        //saveProgress
        //commit('',payload)
        const payload = [{codeItem: data}];
        console.log('-------------match-----------', data);

        dispatch('saveScoreAndProgress', payload);
        //if any code match stamp that code

        commit('stampMainCodeItem', data);
      }
    },

    saveChapterProgress({commit}, payload) {
      Service.v3SaveChapterProgress(payload)
        .then((res) => {
          commit('saveScoreAndProgress', res.data.data);
          console.log('Save Chapter Progress Success');
        })
        .catch((error) => {
          console.log('Error saveContent', error);
        });
    },
    v3LessonLock({commit}, payload) {
      Service.v3LessonLock(payload)
        .then((res) => {
          commit('v3LessonLockOn', res.data.data);
        })
        .catch((error) => {
          console.log('Error saveContent', error);
          commit('v3LessonLockOff');
        });
    },
  },

  getters: {
    getTemplates(state) {
      return state.templates;
    },
    getCourseProgress(state) {
      return state.courseProgress;
    },
    saveScoreAndProgress(state) {
      return state.saveScoreAndProgress;
    },
    v3CourseEnroll(state) {
      console.log('v3CourseEnroll', state.isEnroll);
      return state.isEnroll;
    },
    v3IsEnroll(state) {
      return state.v3EnrollData;
    },
    v3IsTeaching(state) {
      return state.v3TeacherCourse;
    },
    v3NotifyEnroll(state) {
      return state.notifyEnroll;
    },
    v3LessonLock(state) {
      return state.lessonLock;
    },
  },
};

export default v3Module;
